
















import {Country} from "src/modules/country/models/dto.model";
import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class CompanyDisplayComponent extends Vue {
	@Prop({default: false})
	public readonly squared!: boolean;

	@Prop()
	public readonly country!: Country;

	@Prop()
	public readonly countries!: Country[];

	public getIcon(country: Country) : string {
		return (this.squared ? 'flag-icon-squared ' : '') + `flag-icon-${country.alpha2Code.toLowerCase()}`;
	}
}
